import component from "./FirstAnnounce";
export default component;
